(function($) {
  "use strict";
// let's go...
// ======================================================================================================


/*---------------------------------------
    #Cookie note
---------------------------------------*/
$(document).ready(function() {
    if(localStorage.getItem('popState') != 'shown'){
        $("#popup").delay(2000).fadeIn();
        localStorage.setItem('popState','shown');
    }
    $('#popup-close').click(function(e) {
        e.preventDefault();
        $('#popup').fadeOut();
    });
});


/*---------------------------------------
    #initAccordions()
---------------------------------------*/
function initAccordions() {
    $('.js-accordion__content').hide();
    $('.js-accordion__toggle, .js-accordion__titletoggle').css('cursor', 'pointer');
    $(document).on('click', '.js-accordion__toggle', function(e){
        e.preventDefault();
        var $this = $(this);
        $this.toggleClass('is-collapsed');
        $this.parent().next('.js-accordion__content').slideToggle(200);
    });
    $(document).on('click', '.js-accordion__titletoggle', function(e){
        e.preventDefault();
        var $this = $(this);
        $this.next('.js-accordion__toggle').toggleClass('is-collapsed');
        $this.parent().next('.js-accordion__content').slideToggle(200);
    });
}



/*------------------------------------*\
    #document.ready
\*------------------------------------*/
$(document).ready(function() {

    initAccordions();



    /*---------------------------------------
        #Sticky header
    ---------------------------------------*/
    var sticky = new Waypoint.Sticky({
        element: $('.js-wsticky')[0]
    });
    var waypoints = $('.js-triggerup').waypoint(function(direction) {
        if (direction === 'down') {
            $('.js-goup').addClass('is-visible');
        } else if (direction === 'up') {
            $('.js-goup').removeClass('is-visible');
        }
    }, {offset: '85%'});



    /*---------------------------------------
        #home slider
    ---------------------------------------*/
    var $homeSlider = $('.js-homeslider').flickity({
        contain        : true,
        prevNextButtons: false,
        pageDots       : true,
        wrapAround     : true,
        adaptiveHeight : true,
        imagesLoaded   : true,
    });
    /* previous */
    var $previousButtonHomeSlider = $('.js-homeslide-prev').on( 'click', function(e) {
        e.preventDefault();
        $('.js-homeslider').flickity('previous');
    });
    /* next */
    var $nextButtonHomeSlider = $('.js-homeslide-next').on( 'click', function(e) {
        e.preventDefault();
        $('.js-homeslider').flickity('next');
    });




    /*---------------------------------------
        #Home Sponsors slider
    ---------------------------------------*/
    var $sponsorsCarousel = $('.js-sponsorslider').flickity({
        contain         : true,
        prevNextButtons : false,
        pageDots        : true,
        wrapAround      : false,
        groupCells      : true,
        adaptiveHeight  : true,
        imagesLoaded    : true,
    });
    /* previous */
    var $previousButtonHomeSponsorSlider = $('.js-sponsorslider-prev').on( 'click', function(e) {
        e.preventDefault();
        $sponsorsCarousel.flickity('previous');
    });
    /* next */
    var $nextButtonHomeSponsorSlider = $('.js-sponsorslider-next').on( 'click', function(e) {
        e.preventDefault();
        $sponsorsCarousel.flickity('next');
    });
    $( window ).on( 'load', function() {
        $sponsorsCarousel.flickity('resize');
    });



    /*---------------------------------------
        #Submenu indicator
    ---------------------------------------*/
    $('.c-mobilenav').find("li:has(>ul)").each(function(){
        $(this).append("<span class='c-mobilenav__indicator  js-show-submenu'><?xml version=\"1.0\" encoding=\"UTF-8\"?><svg width=\"13px\" height=\"8px\" viewBox=\"0 0 13 8\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><polygon fill-rule=\"nonzero\" points=\"6.5 5.08578644 2 0.585786438 0.585786438 2 6.5 7.91421356 12.4142136 2 11 0.585786438\"></polygon></svg></span>");
    });
    $(document).on('click', '.js-show-submenu', function(e){
        e.preventDefault();
        $(this).toggleClass('is-active');
        $(this).parent().find('ul').toggle();
    });



    /*---------------------------------------
        #Fitvids
    ---------------------------------------*/
    $("body").fitVids();

    /*------------------------------------*\
        #Show/hide menu
    \*------------------------------------*/
    $(document).on('click', '.js-show-menu', function(e){
        e.preventDefault();
        $('body').toggleClass('is-menuopen');
    });

    /*---------------------------------------
        #Animated scroll to #anchor
    ---------------------------------------*/
    $(document).on('click', '.js-goup', function(e){
        e.preventDefault();
        $('html,body').scrollTo('#top', {
            duration: 500,
        });
    });

});
// ----------------------------------
// END - document.ready




//  Responsive js (https://github.com/ten1seven/jRespond)
//  ======================================================
var jRes = jRespond([
    {
        label : 'phone',
        enter : 0,
        exit  : 767
    },{
        label : 'tab',
        enter : 768,
        exit  : 1023
    },{
        label : 'lap',
        enter : 1024,
        exit  : 1279
    },{
        label : 'desk',
        enter : 1280,
        exit  : 10000
    }
]);

jRes.addFunc([
    {
        breakpoint: ['phone'],
        enter : function() {},
        exit  : function() {}
    },{
        breakpoint: ['tab'],
        enter : function() {},
        exit  : function() {}
    },{
        breakpoint: ['lap'],
        enter : function() {},
        exit  : function() {}
    },{
        breakpoint: ['desk'],
        enter : function() {},
        exit  : function() {}
    },{
        breakpoint: ['phone','tab'],
        enter : function() {

            /*---------------------------------------
                #Scroll to hash
            ---------------------------------------*/
            $(document).on('click', '.js-scrolltolearnmore', function(e){
                e.preventDefault();
                $('html,body').scrollTo('#learnmore', {
                    duration: 500,
                    offset: -108,
                });
            });
            $(document).on('click', '.js-gotosponsor', function(e){
                e.preventDefault();
                $('html,body').scrollTo(this.hash, {
                    duration: 500,
                    offset: -108,
                });
            });

        },
        exit  : function() {}
    },{
        breakpoint: ['lap', 'desk'],
        enter : function() {

            $('body').removeClass('is-menuopen');

            /*---------------------------------------
                #Scroll to hash
            ---------------------------------------*/
            $(document).on('click', '.js-scrolltolearnmore', function(e){
                e.preventDefault();
                $('html,body').scrollTo('#learnmore', {
                    duration: 500,
                    offset: -183,
                });
            });
            $(document).on('click', '.js-gotosponsor', function(e){
                e.preventDefault();
                $('html,body').scrollTo(this.hash, {
                    duration: 500,
                    offset: -280,
                });
            });

        },
        exit  : function() {}
    },
]);
//  END - Responsive js
//  ======================================================


// ======================================================================================================
// the end
})(jQuery);
